// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LIPuj","inner":"styles_inner__7csHk","row":"styles_row__CbK_k","total":"styles_total__dSTZI","fee":"styles_fee__sxR8_"};